// https://raw.githubusercontent.com/domagojpa/oib-validation/main/JavaScript/oib-validation.js with changes
import defaultConfiguration from '../config/default.json';
import readConfig from './readClientConfiguration';

const vatNumberLength = readConfig(defaultConfiguration, 'vatNumberLength');
const lengthRegex = new RegExp(`^\\d{${vatNumberLength}}$`);

export default function isVATValid(input) {
  const vat = input.toString().trim();

  if (!lengthRegex.test(vat)) {
    return false;
  }

  let calculated = 10;

  for (const digit of vat.substring(0, vatNumberLength - 1)) {
    calculated += parseInt(digit, 10);

    calculated %= 10;

    if (calculated === 0) {
      calculated = 10;
    }

    calculated *= 2;

    calculated %= 11;
  }

  let check = 11 - calculated;

  if (check === 10) {
    check = 0;
  }

  return check === parseInt(vat[vatNumberLength - 1], 10);
}
